module.exports = "4cf2f26a4bca2b00540acc7ead6ccb7e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/cursor_click.png
// module id = 109
// module chunks = 0